<script>
import CustomTextField from "../CustomInput/CustomTextField.vue";
import {confirmOtp, getOtp} from "../../api/user";
import OtpInput from "./OtpInput.vue";
import {startCountdown} from "../../utils/countdown";

// Backend-ийн otp.resendSecond-тэй тохирно
const DEFAULT_RESEND_SECONDS = 120;

export default {
  name: "ConfirmDialog",
  components: {OtpInput, CustomTextField},
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  emits: ["close", "success"],
  computed: {
    isButtonDisabled() {
      return this.countdown > 0
    },
    user() {
      return this.$store.getters['user/user']
    },
  },
  data() {
    return {
      mobilenumber: '',
      otpStatus: 'not_sent',
      otpCode: '',
      otpError: '',
      otpToken: null,
      countdown: 0,
      stopTimer: null,
      loading: false,
    }
  },
  watch: {
    // Диалог дахин нээгдэхэд амжилттай төлөвөөс эхлэхгүй. OTP оруулж байх үеийн төлөвийг хадгална.
    show(isOpen) {
      if (isOpen && this.otpStatus === 'confirmed') {
        this.resetForm()
      }
    },
  },
  methods: {
    resetForm() {
      this.mobilenumber = ''
      this.otpStatus = 'not_sent'
      this.otpCode = ''
      this.otpError = ''
      this.otpToken = null
    },
    async getOtp() {
      try {
        this.loading = true
        this.otpError = ''
        const res = await getOtp(this.mobilenumber)
        this.otpToken = res.data.access_token
        this.otpStatus = 'sent'
        this.startCountdown(res.data.resend_seconds || DEFAULT_RESEND_SECONDS)
      } catch (e) {
        const data = e && e.response && e.response.data
        // Саяхан код авсан: хүлээх хугацааг товчин дээр харуулна
        if (data && data.code === 'OTP_COOLDOWN') {
          this.otpError = this.$t('forgot_password.otp_cooldown')
          this.startCountdown(data.seconds)
        } else if (data && data.message) {
          this.otpError = e.response.data.message
        }
      } finally {
        this.loading = false
      }
    },
    async submitOtp() {
      try {
        this.loading = true
        this.otpError = ''
        console.log("Утасны дугаар шалгах:", this.mobilenumber)
        const res = await confirmOtp(this.otpCode, this.mobilenumber, this.otpToken)
        this.otpStatus = 'confirmed'
        await this.$store.dispatch('user/fetchUser')
      } catch (e) {
        if (e && e.response && e.response.data && e.response.data.message) {
          this.otpError = e.response.data.message
        }
      } finally {
        this.loading = false
      }
    },
    startCountdown(seconds) {
      this.stopCountdown()
      this.stopTimer = startCountdown(seconds, (left) => {
        this.countdown = left
      })
    },
    stopCountdown() {
      if (this.stopTimer) this.stopTimer()
      this.stopTimer = null
      this.countdown = 0
    },
  },
  beforeDestroy() {
    this.stopCountdown()
  },
}
</script>

<template>
  <ic-dialog :show="show">
    <div class="dialog-box">
      <a @click.stop="$emit('close')" class="icon-btn close-btn mr-row close-button">
        <i class='sr sr-close'></i>
      </a>

      <div v-if="otpStatus === 'not_sent'">
        <h4 class="text-center mb-xl-4">{{ $t('kyc.confirm.phone') }}</h4>
        <p class="card-text card-title">{{ $t('register.info_phone') }}</p>
        <CustomTextField label="Утасны дугаар / Phone number:" v-model="mobilenumber"/>
        <span v-if="otpError" class="error pt-2 my-2" style="color: red;">{{ otpError }}</span>
        <div class="d-flex justify-content-center">
          <ic-button class="card-button" size="tn" :disabled="mobilenumber.length !== 8 || isButtonDisabled" :loading="loading" @click="getOtp">
            {{ $t('register.get_code') }}<template v-if="isButtonDisabled"> ({{ countdown }} сек)</template>
          </ic-button>
        </div>
      </div>

      <div v-else-if="otpStatus === 'sent'">
        <h4 class="text-center mb-xl-3 font-weight-bold">Баталгаажуулалт</h4>
        <img src="/img/otp.svg" style="display: block; margin: 20px auto;" height="60"/>
        <p class="text-center card-text card-title mb-xl-4 mt-2 px-3 text-muted">
          Таны утасны дугаар руу илгээсэн <br> 
          <strong>6 оронтой</strong> баталгаажуулах кодыг оруулна уу.
        </p>  
        <div class="mb-4 d-flex justify-content-center">
          <otp-input v-model="otpCode"/>
        </div>  
        <span v-if="otpError" class="error pt-2 my-2 text-center" style="color: red; font-size: 14px;">
            {{ otpError }}
          </span>
        <div class="d-flex gap-3 justify-content-between mt-xl-4" style="gap: 15px;">
          <ic-button v-if="isButtonDisabled" disabled class="w-50 card-button" size="tn">
            {{ countdown }} сек
          </ic-button>
          <ic-button v-else class="w-50 card-button" size="tn" :loading="loading" @click="getOtp">
            Дахин код авах
          </ic-button>          
          <ic-button class="w-50 card-button" size="tn" :disabled="otpCode.length !== 6" :loading="loading" @click="submitOtp">
            Баталгаажуулах
          </ic-button>
        </div>
      </div>

      <div v-else-if="otpStatus === 'confirmed'">
        <div>
          <img src="../../assets/images/check-green.svg" style="display: block; margin-left: auto; margin-right: auto" />
<!--          <div class="circle-overlay"></div>-->
        </div>
        <h4 class="text-center my-xl-3">Амжилттай</h4>
        <p class="text-center card-text card-title mt-2">Утасны дугаар амжилттай бүртгэгдлээ.</p>

        <div class="d-flex justify-content-center mt-xl-5">
          <ic-button size="tn" @click="$emit('close')">Хаах</ic-button>
        </div>
      </div>
    </div>
  </ic-dialog>
</template>

<style scoped lang="scss">
.dialog-box {
  position: relative;
}

.contract-view {
  margin-left: 20px !important;
  margin-right: 20px !important;
  padding-bottom: 60px !important;
}

.contract-view p {
  font-size: 0.6rem !important;
  line-height: 1.2rem !important;
}

.contract-view h5 {
  font-size: 0.5rem !important;
  line-height: 1rem !important;
}

.contract-wrapper {
  max-width: 80vh;
  //width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.close-button {
  position: absolute;
  top: 6px;
  right: 0px;
}

.contract-check {
  display: block;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 14px;
  color: var(--text-primary-color);
}

//button {
//  background: #0C293A !important;
//}

.desc-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #939393;
  text-align: center;
}

.circle-overlay {
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: lightblue;
  border-radius: 50%;
  z-index: 0;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
}

</style>
